<template>
  <div>
    <div class="row">
      <div class="col-6">
        <div class="mb-2">
          <label for="rfname">
            <small>{{ 'First name' | translate }}</small>
          </label>
          <input
            id="rfname"
            class="form-control"
            :class="{ 'is-invalid': 'name' in errors }"
            type="text"
            v-model="first_name"
          />
        </div>
      </div>
      <div class="col-6">
        <div class="mb-2">
          <label for="rflastname">
            <small>{{ 'Last name' | translate }}</small>
          </label>
          <input
            id="rflastname"
            class="form-control"
            :class="{ 'is-invalid': 'last_name' in errors }"
            type="text"
            v-model="last_name"
          />
        </div>
      </div>
    </div>

    <div class="mb-2">
      <label for="remail">
        <small>{{ 'Email' | translate }}</small>
      </label>
      <input
        id="remail"
        class="form-control"
        :class="{ 'is-invalid': 'email' in errors }"
        type="email"
        v-model="email"
      />
      <div class="invalid-feedback">
        <small>
          {{ 'Already have an account?' | translate }}
          <a href="#" @click.prevent="openModal">
            {{ 'Sign in' | translate }}
          </a>
        </small>
      </div>
    </div>

    <div class="mb-2">
      <label for="rpassword">
        <small>{{ 'Password' | translate }}</small>
      </label>
      <input
        if="rpassword"
        class="form-control"
        :class="{ 'is-invalid': 'password' in errors }"
        type="password"
        v-model="password"
      />
      <small><InputErrors name="password"></InputErrors></small>
    </div>
  </div>
</template>

<script>
import InputErrors from './InputErrors'

export default {
  data() {
    return {}
  },
  components: {
    InputErrors,
  },
  computed: {
    errors() {
      return this.$store.state.errors
    },
    first_name: {
      get() {
        return this.$store.state.registrationData.name
      },
      set(name) {
        this.$store.commit('setRegistrationData', { name })
      },
    },
    last_name: {
      get() {
        return this.$store.state.registrationData.last_name
      },
      set(last_name) {
        this.$store.commit('setRegistrationData', { last_name })
      },
    },
    email: {
      get() {
        return this.$store.state.registrationData.email
      },
      set(email) {
        this.$store.commit('setRegistrationData', { email })
      },
    },
    password: {
      get() {
        return this.$store.state.registrationData.password
      },
      set(password) {
        this.$store.commit('setRegistrationData', { password })
      },
    },
  },
  methods: {
    openModal() {
      this.$parent.$refs.login.email = this.email
      this.$parent.$refs.login.openModal()
    },
    setView() {
      this.$store.commit('setView', 'login')
    },
  },
}
</script>
